import type { SVGProps } from "react";
export interface WatchPulseIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function WatchPulseIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: WatchPulseIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.933 18.644a1.125 1.125 0 0 1 2.134.712l-.544 1.633a3.12 3.12 0 0 1-2.964 2.136h-3.117a3.13 3.13 0 0 1-2.877-1.902l-.088-.234-.545-1.634-.03-.11a1.125 1.125 0 0 1 2.123-.708l.043.107.543 1.633c.12.357.454.598.83.598h3.118c.376 0 .71-.241.83-.598zm-.908-11.268c.474.01.893.317 1.043.768l1.243 3.73H19a1.125 1.125 0 0 1 0 2.25h-3.5c-.484 0-.915-.31-1.068-.769l-.508-1.524-1.374 3.572a1.126 1.126 0 0 1-2.057.1L9.25 13.016l-.244.487c-.19.381-.58.621-1.006.621H5a1.125 1.125 0 0 1 0-2.25h2.304l.94-1.877.08-.137a1.125 1.125 0 0 1 1.932.137l1.109 2.219 1.585-4.12.076-.159c.203-.352.584-.57.999-.561M20 6.875c.621 0 1.125.504 1.125 1.125v2c0 .62-.504 1.124-1.125 1.124h-1A1.123 1.123 0 0 1 18.492 9 1.12 1.12 0 0 1 19 6.875zm-6.44-6c1.344 0 2.537.861 2.963 2.137l.544 1.632a1.126 1.126 0 0 1-2.134.712l-.545-1.633a.875.875 0 0 0-.829-.598h-3.117a.88.88 0 0 0-.83.598l-.544 1.633a1.126 1.126 0 0 1-2.136-.712l.545-1.632.088-.234A3.13 3.13 0 0 1 10.442.875z"
      />
      <path
        fill={color}
        d="M17.875 8c0-1.036-.84-1.875-1.876-1.875H8c-1.036 0-1.875.84-1.875 1.875v8c0 1.035.84 1.875 1.875 1.875h8c1.035 0 1.875-.84 1.875-1.876zm2.25 8a4.125 4.125 0 0 1-4.126 4.125H8a4.125 4.125 0 0 1-4.125-4.126V8A4.125 4.125 0 0 1 8 3.875h8A4.125 4.125 0 0 1 20.124 8v8Z"
      />
    </svg>
  );
}
